/* global $ */

import _ from '../Manager'
import app from '../App/App'
import html from './Bowling.html'
import Mustache from 'mustache'
import Page from '../Page'

class Bowling extends Page{
    id;
    reservas=[]
    currDay= new Date()
    timer= 0 


    constructor(){
        super()
        _.events.on( 'show', this.onShow, this )
        _.events.on( 'hide', this.onHide, this )
        this.refresh()
    }

    html(){
        let [day, weekday]= this.formatCurrDay()
        return Mustache.render(html, {gridHtml: this.renderGrid(), currday: day, currday_wd: weekday, reservasCount: this.reservas.length})
    }

    renderGrid(){
        let sesionesHtml=''
        for (let i=0; i < app.sesiones.length; i++) {
            sesionesHtml+=`<div>${app.sesiones[i].id}
                <div id="ses_${i}_count" class="count zero"><span id='ses_${i}_count_text'>0</span>
                &nbsp;<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon" >
					<path fill-rule="evenodd" d="M1.5 6.375c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v3.026a.75.75 0 01-.375.65 2.249 2.249 0 000 3.898.75.75 0 01.375.65v3.026c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 17.625v-3.026a.75.75 0 01.374-.65 2.249 2.249 0 000-3.898.75.75 0 01-.374-.65V6.375zm15-1.125a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0V6a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0v.75a.75.75 0 001.5 0v-.75zm-.75 3a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75zm.75 4.5a.75.75 0 00-1.5 0V18a.75.75 0 001.5 0v-.75zM6 12a.75.75 0 01.75-.75H12a.75.75 0 010 1.5H6.75A.75.75 0 016 12zm.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" clip-rule="evenodd" />
			  	</svg>
                </div>
            </div>`
        }

        let pistasHtml=''
        for (let i=1; i <= 16; i++ ) pistasHtml+=`<div>${i}</div>`

        let contentHtml= ''

        return(`
        <div class="grid-container">
            <div class="grid-corner"></div>
            <div class="grid-colheader">${pistasHtml}</div>
            <div class="grid-rowheader">${sesionesHtml}</div>
            <div id="_RESERVAS_" class="grid-content">${contentHtml}</div>
        </div>
        `)
    }

    incCurrDay( delta ){
        let day= new Date(this.currDay)
        day.setDate( day.getDate() + delta)
        this.changeCurrDay( day )
    }

    changeCurrDay( day ){
        this.currDay= day
        this.updateDate()
        this.refresh()
    }

    formatCurrDay(){
        return [
            this.currDay.toISOString().substring(0, 10)
            , this.currDay.toLocaleString('default', {weekday: 'long'}).toUpperCase()
        ]
    }

    updateDate(){
        let[day, weekday]= this.formatCurrDay()
        document.getElementById('_CURRDAY_').innerHTML= day
        document.getElementById('_CURRDAY_WD_').innerHTML= weekday
    }

    refresh(){
        console.log('refreshing...', this.currDay.toISOString().substring(0, 10))
        this.borraReservas()

        _.request('eta-call', 'reservas_diarias', {dia: this.currDay.toISOString().substring(0, 10)} )
        .then( this.cargaReservas.bind(this) )
    }

    onShow(){
        if (! this.timer ){
            this.timer= setInterval( this.refresh.bind(this), 5 * 60000 ) // cada 5 minutos refresca.
            console.log('setting timer: ' + this.timer)
        } else {
            console.log('ERROR: Setting timer por duplicado. timer actual:' + this.timer)
        }
        if ( this.reservas.length > 0 ) this.cargaReservas( this.reservas )
    }

    onHide(){
        if (this.timer) {
            console.log('clearing timer:' + this.timer)
            clearInterval( this.timer )
            this.timer= 0
        } else {
            console.log('ERROR: Try to clearing no timer')
        }
    }

    borraReservas(){ 
        this.reservas= []
        let root=document.getElementById('_RESERVAS_')
        if (root) root.innerHTML=''
        this.clearSesCounts() 
    }

    cargaReservas( reservas ){
        let html= '', count= 0
        this.reservas=[]
        reservas.forEach( reserva =>{
            let pista, sesion, nombre, comunicacion, inicio
            count++
            [pista, sesion]= this.getCoordsFromTime( new Date(reserva.Time) )
            nombre= `${reserva.Name} ${reserva.Surname}`
            comunicacion= reserva.Phone
            inicio= new Date(reserva.Time).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
            html+= `<div class="cell trk${pista} ses${sesion}" onclick="_('muestraReserva', ${reserva.SaleId})">
                <div class="cell__hd">${nombre}</div>
                <div class="cell__body">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
		            <path fill-rule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z" clip-rule="evenodd" />
	            </svg>
                &nbsp;${comunicacion}</div>
                <div class="cell__ft">${inicio}</div>
            </div>`
            this.reservas.push({
                pista: pista,
                sesion: sesion,
                hora: inicio,
                ...reserva
            })
        })
        let root=document.getElementById('_RESERVAS_')
        if (root) root.innerHTML= html
        root=document.getElementById('_RESERVAS_COUNT_')
        if (root) root.innerHTML= ''+ this.reservas.length
        this.updateSesCounts()
    }

    clearSesCounts(){
        for (let i=0; i < app.sesiones.length; i++) $( `#ses_${i}_count` ).addClass('zero')
    }

    updateSesCounts(){
        let sesId, count
        for (let i=0; i < app.sesiones.length; i++) {
            sesId= `#ses_${i}_count`
            if (count= this.reservas.filter( reserva => reserva.sesion - 1 == i ).length ){
                $( sesId ).removeClass('zero')
                $( sesId + '_text' ).html( count )
            } else $( sesId ).addClass('zero')
        }
    }

    muestraReserva( saleId ){
        console.log( saleId )
        let reserva = this.reservas.find( reserva => reserva.SaleId == saleId )
        _.openModal( 'Booking', reserva )
    }

    getCoordsFromTime( date ){
        // correcciones. Si una venta me viene la misma persona( dentro de la misma venta )

        let hora= date.getHours(), minutos= date.getMinutes()
        let inicio= hora * 60 + minutos // minutos del día.
        let sesion= app.sesiones.findIndex( sesion => sesion.inicio >= inicio ) + 1
        let pista= 1
        this.reservas.forEach( reserva => { if (reserva.sesion == sesion) pista++ } )
        return [pista, sesion]
    }

    openWeekBooking(){
        _.open( 'WeekBooking', null, this.reload )
    }

    reload( day ){
        if( day && day !== this.currDay.toISOString().substring(0,10) ){
            this.changeCurrDay( new Date(day) )
        }

    }

}


export default Bowling